// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__Gush9","rotation":"Spinner_rotation__vsPS-"};